import { render, staticRenderFns } from "./TemplateModule.vue?vue&type=template&id=675614f0"
import script from "./TemplateModule.vue?vue&type=script&lang=js"
export * from "./TemplateModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports